<template>
    <footer class="foot">
        <div class="community ob-pinkable">
            <div>
                <div class="community-t">Join the One community.</div>
                <div class="community-d">Customers who help shape what we build next — and hear about changes on the network first.</div>
            </div>
            <a href="#contact" class="community-cta ob-press">Get involved →</a>
        </div>

        <div class="foot-grid">
            <div>
                <img src="/assets/logo-blue.svg" alt="One Broadband" class="foot-logo">
                <p class="foot-blurb">One Broadband (SL) Ltd — fibre-grade home and business internet across Freetown, with a team that lives here.</p>
            </div>
            <div>
                <div class="foot-k">Company</div>
                <div class="foot-links">
                    <a href="#about">About us</a><a href="#technology">Technology</a><a href="#loyalty">Loyalty programme</a><a href="#faq">FAQ</a>
                </div>
            </div>
            <div>
                <div class="foot-k">Offerings</div>
                <div class="foot-links">
                    <a href="#offer">Home packages</a><a href="#offer">One Business</a><a :href="COVERAGE_URL" target="_blank" rel="noopener">Coverage map ↗</a>
                </div>
            </div>
            <div>
                <div class="foot-k">Contact</div>
                <div class="foot-links">
                    <span>{{ ADDRESS }}</span>
                    <a href="tel:3333">{{ PHONE_DISPLAY }}</a>
                    <a :href="`mailto:${EMAIL}`">{{ EMAIL }}</a>
                </div>
            </div>
        </div>

        <div class="legal">
            <span>© One Network. All rights reserved.</span>
            <div class="legal-links"><a href="#">Privacy Policy</a><a href="#">Terms of Service</a></div>
        </div>
    </footer>
</template>

<script lang="ts" setup>
    import { ADDRESS, COVERAGE_URL, EMAIL, PHONE_DISPLAY } from '@/data/content'
</script>

<style scoped>
    .foot { max-width: 1240px; margin: 0 auto; padding: 0 44px 120px; }
    .community {
        border-radius: 26px;
        padding: 34px 40px;
        color: var(--ob-white);
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        background: var(--ob-grad-footer);
        box-shadow: var(--ob-shadow-glow-lg);
    }
    .community-t { font-size: 22px; font-weight: 700; letter-spacing: -.018em; }
    .community-d { margin-top: 5px; font-size: 15px; color: var(--ob-w-a92); }
    .community-cta {
        background: var(--ob-white);
        color: var(--ob-blue);
        font-weight: 700;
        padding: 15px 28px;
        border-radius: 999px;
        white-space: nowrap;
        text-decoration: none;
    }

    .foot-grid {
        margin-top: 44px;
        display: grid;
        grid-template-columns: 1.5fr 1fr 1fr 1fr;
        gap: 44px;
        padding-bottom: 34px;
        border-bottom: 1px solid var(--ob-navy-a13);
    }
    .foot-logo { height: 30px; display: block; }
    .foot-blurb { margin: 20px 0 0; max-width: 290px; font-size: 14px; line-height: 1.65; color: var(--ob-ink-faint); }
    .foot-k { font-size: 12px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--ob-blue-deep); margin-bottom: 16px; }
    .foot-links { display: grid; gap: 11px; font-size: 14px; color: var(--ob-ink-sub); }
    .foot-links a { color: var(--ob-ink-sub); text-decoration: none; }

    .legal {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        padding-top: 24px;
        font-size: 13px;
        color: var(--ob-ink-faint);
    }
    .legal-links { display: flex; gap: 26px; }
    .legal-links a { color: var(--ob-ink-faint); text-decoration: none; }

    @media (max-width: 1024px) {
        .foot-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
    }
    @media (max-width: 700px) {
        .foot { padding: 0 20px 130px; }
        .community { padding: 24px 22px; }
    }
    @media (max-width: 640px) {
        .foot-grid { grid-template-columns: 1fr; }
    }
</style>
